export default "__VITE_ASSET__B4PZ5TL6__"